
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { ReminderTemplate } from "@/models/reminder-template";
import { ReminderService } from "@/services/reminder-service";
import { BrowserInfo } from "@/utils/browser";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppReminderDocumentsLayoutEditElectronProperties from "./ReminderDocumentsLayoutEditElectronProperties.vue";
import { ElectronFunctions } from "@/utils/electron/electron";
import { IElectronPrinter } from "@/utils/electron/electron-printer";

export default Vue.extend({
	data() {
		return {
			reminder: 1,
			lang: "",
			editElectronPropertiesLayoutId: 0,
			printers: [] as IElectronPrinter[],
		};
	},
	props: {
		templates: {
			type: Array as () => ReminderTemplate[],
			required: true
		},
		layouts: {
			type: Array as () => DocumentLayoutInfo[],
			required: true,
		}
	},
	computed: {
		reminderTemplates(): ISelectItem< number>[] {
			return this.templates.map(r => {
				return {
					text: r.getName(),
					value: r.ReminderID
				};
			});
		},
		template():ReminderTemplate | null {
			return this.templates[+this.reminder - 1];
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		}
	},
	methods: {
		async deleteLayout(layout: DocumentLayoutInfo) {
			let confirmMessage = this.$ct("layout-deleteConfirm");
			let confirmTitle = this.$t("common.warning");
			let yesText = this.$t("common.yes");
			let noText = this.$t("common.no");
			let result = await this.$wf.confirm(confirmMessage, yesText, noText, confirmTitle, "warning");
			if (result) {
				await ReminderService.deleteReminderLayouts([layout]);
				this.$emit("update-layouts");
				let i = this.layouts.indexOf(layout);
				if (i != -1) {
					this.layouts.splice(i, 1);
				}
			}
		},
		restoreTemplates(){
			this.$emit("restore-email-templates");
		},
		editElectronProperties(layout:DocumentLayoutInfo){
			this.editElectronPropertiesLayoutId = layout.ID;
		},
	},
	async mounted(){
		if (BrowserInfo.hasElectronConfigured()){
			this.printers = await ElectronFunctions.getPrinters();
		}
	},
	components: {
		AppCustomLanguageSelect,
		AppReminderDocumentsLayoutEditElectronProperties
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
